import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Dialogs, useDialogs } from '../../sharedComponents/src/Contexts/DialogsContext'
import { analyticsManager } from '../../sharedComponents/src/globalHeader/services/analytics/AnalyticsManager'
import { getAppConfig } from '../../sharedComponents/src/globalHeader/services/AppConfigService'
import { Popup } from '../../sharedComponents/src/Popup/Popup'
import { useStoreActions, useStoreState } from '../../store/hooks'
import { GameViewState } from '../gameView/GameViewModel'

export const PopupService = () => {
    const { registerDialog, unregisterDialog } = useDialogs()
    const navigate = useNavigate()
    const { shareLocation, removePopups } = useStoreActions((actions) => actions.popupService)
    const { popups } = useStoreState((state) => state.popupService)
    const gameState = useStoreState((state) => state.gameView.gameState)
    const [popup] = popups

    const { isConnected } = useStoreState((state) => state.ws)
    const { pathname } = useLocation()

    useEffect(() => {
        if (Boolean(popup)) {
            registerDialog(
                Dialogs.POPUP_SERVICE,
                <Popup popup={popup} handleClose={handleClose} handleCTA={handleCTA} />,
            )
            analyticsManager.dispatchEvent('popupTriggered', {
                popupName: popup.name,
                popupId: popup.popupId,
            })
        }

        return () => unregisterDialog(Dialogs.POPUP_SERVICE)
    }, [popup])

    useEffect(() => {
        if (popup) {
            if (gameState === GameViewState.GAME_RUNNING || gameState === GameViewState.GAME_PRELOADING) {
                unregisterDialog(Dialogs.POPUP_SERVICE)
            }
        }
    }, [gameState, popup])

    useEffect(() => {
        if (isConnected) {
            if (pathname === '/') {
                shareLocation('/play')
            } else {
                shareLocation(pathname)
            }
        }
    }, [isConnected, pathname])

    const handleClose = () => {
        removePopups()
    }

    const handleCTA = (url) => {
        handleClose()
        if (url) {
            if (url.includes(window.location.origin)) {
                const parsedUrl = url.replace(window.location.origin, '')
                navigate(parsedUrl)
            } else {
                window.location.href = url
            }
        }
    }

    return null
}
